<template>
  <div
    class="fixed inset-0 z-10 overflow-y-auto"
    :class="show ? 'visible' : 'invisible'"
    role="dialog"
  >
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center">
      <div
        class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-all duration-300"
        :class="show ? 'opacity-100' : 'opacity-0'"
      />

      <div
        class="inline-block overflow-hidden text-left align-bottom transform bg-white rounded shadow-xl max-w-lg w-full transition-all duration-300"
        :class="show ? 'opacity-100 scale-100' : 'opacity-0 scale-75'"
      >
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExternalModal',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>
